import { type ITaxableCellProps } from "commonComponents/utilities/LineItemContainer/cellImplementations/TaxCell/TaxCell";
import { TaxesCell } from "commonComponents/utilities/LineItemContainer/cellImplementations/TaxesCell/TaxesCell";
import { GridLineItemColumnType } from "commonComponents/utilities/LineItemContainer/types/LineItem.enums";
import { type ILineItemColumn } from "commonComponents/utilities/LineItemContainer/types/LineItem.interfaces";
import {
    type ITaxLineItem,
    LineItemColumns,
} from "commonComponents/utilities/LineItemContainer/types/LineItem.types";

export const getTaxesCellDefaultConfig = <T extends ITaxLineItem>() =>
    ({
        id: LineItemColumns.Tax,
        name: "Tax",
        jsonKey: "taxGroupId",
        width: 125.0,
        align: "left",
        isSortable: false,
        columnType: GridLineItemColumnType.tax,
        isFrozen: false,
        isHidden: false,
        Cell: TaxesCell,
    }) as Partial<ILineItemColumn<T, ITaxableCellProps>>;
